import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import cookies from "js-cookie";
import EditDetailsofMember from "../../Models/EditMeberModel/EditMember";
import AddMember from "../../Models/EditMeberModel/AddMember";
import { GetMembers, DeletetMembers } from "../../apis/api/MemberApi";
import BusinessCardModel from "../../Models/BuisnessCardsModel/BuisnessCardsModel";

const MemberCard = () => {
  const [showMemberModal, setShowMemberModal] = useState(false);
  const [AddMemberModal, setAddMemberModal] = useState(false);
  const [memberData, setmemberData] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [showBuisnessModal, setShowBuisnessModal] = useState(false);
  const [businessCardData, setShowBuisnesscard] = useState();
  const UserID = cookies.get("userID");
  const companyID = cookies.get("company_id");
  const access = JSON.parse(cookies.get("access"));
  const location = useLocation();
  const navigate = useNavigate();
  const { company_id, userId } = location.state || {};

  const dispatch = useDispatch();
  const { contactdata } = useSelector((state) => state.MemberSlice);

  const Openmodel = (data) => {
    setmemberData(data);
    setShowMemberModal(true);
  };

  useEffect(() => {
    (async () => {
      await dispatch(GetMembers({ company_id, userId }));
    })();
  }, [dispatch, company_id, userId]);

  const handleDeleteClick = (memberId) => {
    setSelectedMemberId(memberId);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (selectedMemberId) {
      await dispatch(DeletetMembers({ selectedMemberId }));
      setShowDeleteModal(false);
      setSelectedMemberId(null);
      await dispatch(GetMembers({ company_id, userId }));
    }
  };

  function filterMemeberDataforCard(id) {
    const filterddata = contactdata.data.filter((member) => {
      return member.id == id;
    });
    setShowBuisnesscard(filterddata);
    setShowBuisnessModal(true);
  }
  return (
    <>
      <AddMember
        show={AddMemberModal}
        onHide={() => setAddMemberModal(false)}
        Company_id={company_id}
      />
      <BusinessCardModel
        show={showBuisnessModal}
        handleClose={() => setShowBuisnessModal(false)}
        data={businessCardData}
      />
      <EditDetailsofMember
        show={showMemberModal}
        onHide={() => setShowMemberModal(false)}
        data={memberData}
        company_id={company_id}
        userId={UserID}
      />

      {showDeleteModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.3)" }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowDeleteModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this member?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowDeleteModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleConfirmDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="">

        {(access.extra_contact && access.extra_contact === "1") &&
        (UserID === userId && companyID === company_id) && (
          <button
            className="btn btn-secondary btn-sm z-14 mb-3"
            onClick={() => setAddMemberModal(true)}
          >
            Add Member <i className="bx bx-plus fs-6"></i>
          </button>
        )
        }
        <div
          className="d-flex justify-content-end"
          onClick={() => navigate(-1)}
        >
          {/* <button className="btn btn-secondary btn-sm mb-3">
            <i className="bx bx-left-arrow-alt"></i> Back
          </button> */}
        </div>

        {contactdata.data ? (
          <div className="row">
            {contactdata.data.map((member, index) => {
              const nameParts = [
                member.salutation,
                member.first_name,
                member.middle_name,
                member.last_name,
              ].filter(
                (part) => part && part !== "null" && part !== "undefined"
              );

              const fullName = nameParts.join(" ");
              return (
                <div key={index} className="col-12 col-sm-12 col-md-4 col-lg-3">
                  <div className="our-team rounded-1">
                    <div className="d-flex justify-content-between mt-0">
                      {UserID === userId && companyID === company_id && (
                        <>
                          <button
                            className="btn btn-light btn-sm z-14"
                            onClick={() => Openmodel(member)}
                          >
                            <i className="bx bx-edit fs-6"></i>
                          </button>
                          <button
                            className="btn btn-danger btn-sm z-14 w-5"
                            onClick={() => handleDeleteClick(member.id)}
                          >
                            <i className="bx bx-trash fs-6"></i>
                          </button>
                        </>
                      )}
                    </div>

                    <div className="picture">
                      <img
                        className="img-fluid w-100 h-100"
                        src={
                          member.member_logo ||
                          `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`
                        }
                        alt="team member"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "/gray-avatar-icon-vector-illustration_276184-163.avif";
                        }}
                      />
                    </div>

                    <div className="team-content">
                      {fullName && <span className="name">{fullName}</span>}
                      {member.job_title && (
                        <h6 className="title">{member.job_title}</h6>
                      )}
                    </div>

                    {member.department && (
                      <span>Department: {member.department}</span>
                    )}

                    {member.email && <p className="mt-3">{member.email}</p>}
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      onClick={() => filterMemeberDataforCard(member.id)}
                    >
                      <i class="bx bx-show"></i> View Business Card
                    </button>
                    <ul className="social">
  {/* WhatsApp */}
  {member?.contact && (
  <li>
    <a
      href={`https://wa.me/${String(member.country_code).replace(/\D/g, '')}${String(member.contact).replace(/\D/g, '')}`}
      className="bx bxl-whatsapp"
      aria-hidden="true"
      target="_blank"
      rel="noopener noreferrer"
    ></a>
  </li>
)}



  {/* Phone */}
  {/* {member?.contact && (
    <li>
      <a
        href={`tel:+${member?.country_code}${member?.contact}`}
        className="bx bx-phone"
        aria-hidden="true"
      ></a>
    </li>
  )} */}

  {/* Email */}
  {member?.email && (
    <li>
      <a
        href={`mailto:${member?.email}`}
        className="bx bx-envelope"
        aria-hidden="true"
      ></a>
    </li>
  )}

 
</ul>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p>No members found</p>
        )}
      </div>
    </>
  );
};

export default MemberCard;
